import { render, staticRenderFns } from "./destinatario.vue?vue&type=template&id=7efb0632&scoped=true&"
import script from "./destinatario.vue?vue&type=script&lang=js&"
export * from "./destinatario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efb0632",
  null
  
)

export default component.exports